// extracted by mini-css-extract-plugin
export default {"AboutContainer":"About_AboutContainer__LQ5YL","closeCart":"About_closeCart__O+Z3Q","aboutUs":"About_aboutUs__zmxBe"};